import React, {useState,useEffect,useContext,useRef} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso,DeleteActionButton,ColumDataTableReorganize,FormatedPrice,articleColumnGenerate,customFieldsColumnGenerate,priceSuppColumnGenerate,tauxTvaColumnGenerate,enumereColumnGenerate,articleEditionDatatable,articleDataGenerator,useLocalStorage,articlePriceUnitSuppDataGenerator,ArticleBarSearch,ModalTagPrintForm,Loading} from "@gull";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { IsAuthContext } from 'app/App';
import {scrollXDataTable} from 'app/scrollXDataTable';
import { Modal } from "react-bootstrap";
import {articleListErp} from 'app/columnsArticleListeDataTable'
import FormulaireAjoutArticleStockAdjustment from '../stockAdjustment/FormulaireAjoutArticleStockAdjustment';
import axios from 'axios'
import swal from "sweetalert2"

const useLoadInit = (props) => {
    const t = useTranslate();

    const [loadingSearchItem,setLoadingSearchItem]=useState(false)
    const [listSearchItem,setListSearchItem]=useState([])
    const [datas,setDatas] = useState(listSearchItem)
    const searchInput = useRef('')

    const loadItems = async (inputValue) => {
        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/name/"+inputValue
        ).then((response) => {
            setLoadingSearchItem(false)
            // Seuls les articles suivis en stock (havestock) sont propos\u00E9s \u00E0 l'ajustement de masse
            let datasHavestock = response.data.datas.filter((value) => value.havestock==true)
            setListSearchItem(datasHavestock)
            let ajour = datasHavestock.filter((value)=>value.name.replace(/\u00A0/g,' ').toLowerCase().includes(searchInput.current.value.replace(/\u00A0/g,' ').toLowerCase()))
            setDatas(ajour)
        }).catch((error) => {
            if(error=='end_session') return;
            setLoadingSearchItem(false)
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }
    
    return [loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput]
}

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columnShow.length)
    }, [window.screen.width,props.columnShow.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            pagination={paginationFactory(props.paginationOptions)}
            noDataIndication={t('tableNoData')}
            defaultSortDirection={props.defaultSortDirection}
            hover
            condensed
            responsive
        />
    );
};

const StockAdjustmentDetailTable = (props) => {
    const t = useTranslate();
    const [loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput] = useLoadInit(props)

    const [perPage,setPerPage]=useState(50)

    const [localStorage, setLocalStorage] = useLocalStorage(['article_fields_Stock_Adjustment','article_fields_stock_adjustment_reorganize']);

    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false)
    const [toast,setToast]=useState(false)
    const [validButton,setValidButton]=useState(false)

    const [selectedRows,setSelectedRows]=useState([]) // ids des articles cochés, pour la suppression multiple uniquement
    const allArticleIds = (Object.keys(props.articleListInfo).length!=0) ? props.articleListInfo.list_detail.map(value=>value.article.id) : []
    const allRowsSelected = allArticleIds.length!=0 && allArticleIds.every(id => selectedRows.includes(id))

    // la liste change (ajout/suppression/reset) : on repart d'une sélection vide pour ne pas garder de ligne fantôme cochée
    useEffect(() => {
        setSelectedRows([])
    }, [props.articleListInfo])

    const toggleSelectRow = (mode,articleId) => {
        setSelectedRows(previous => {
            if(mode=='all'){
                return allRowsSelected ? [] : allArticleIds
            }
            return previous.includes(articleId) ? previous.filter(id => id!=articleId) : [...previous,articleId]
        })
    }

    // Supprime en une fois toutes les lignes cochées de la liste en cours (opération locale, avant validation de l'ajustement)
    const bulkDeleteArticles = async () => {
        const result = await swal.fire({
            title: t('typeRemoveX')+selectedRows.length+' '+t('items')+' ?',
            icon: "warning",
            type: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('btnYes'),
            cancelButtonText: t('btnNo'),
        });
        if(!result.value) return;

        props.setArticleListInfo(prev => {
            return {
                ...prev,
                list_detail: prev.list_detail.filter(value => !selectedRows.includes(value.article.id))
            };
        });
        setSelectedRows([])
    }

    const inputQteRef = useRef({})
    const { authParam } = useContext(IsAuthContext);
    const maxConditionnement = (authParam.company.advanceparams.max_conditionnement!='' && authParam.company.advanceparams.max_conditionnement!=null) ? +authParam.company.advanceparams.max_conditionnement : 0
    const suppPrice = authParam.company.advanceparams.hasOwnProperty('prix_supplementaire') ? authParam.company.advanceparams.prix_supplementaire : []
    const categorieTva = (authParam.company.advanceparams.hasOwnProperty('categorie_tva') && authParam.company.advanceparams.categorie_tva!=null) ? authParam.company.advanceparams.categorie_tva : []

    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    let cookieLecture = ['stock','quantity','name','sku','action'];
    if(localStorage.article_fields_Stock_Adjustment){
        let columnShowVar = localStorage.article_fields_Stock_Adjustment;
        cookieLecture = columnShowVar.split(',')
    }
    const [columnShow,setColumnShow] = useState(cookieLecture)   

    useEffect(function () {
        if(Object.keys(props.articleListInfo).length!=0){
            props.articleListInfo.list_detail.map(value => {
                inputQteRef.current[value.article.id] = React.createRef();
            })
        }
    }, [props.articleListInfo])

    //Pour l'impression d'étiquettes de la liste en cours (module partagé avec le WMS, cf ModalTagPrintForm)
    const [showPrintTagModal,setShowPrintTagModal] = useState(false)
    const [articleListPrint,setArticleListPrint] = useState([])
    const [loadPrintList,setLoadPrintList] = useState(false)

    const [inputScan,setInputScan]=useState('')
    const [showArticle,setShowArticle]=useState(false)
    const [zoneArticleListe,setZoneArticleListe] = useState('')
    const [binsArticleListe,setBinsArticleListe] = useState('')
    const [haveBins,setHaveBins] = useState(false)
    const [memo,setMemo] = useState('')
    const [sectionArticleListe,setSectionArticleListe] = useState('')
    const [validData,setValidData] = useState(false)

    // Focus sur l'ArticleBarSearch quand le formulaire s'affiche
    useEffect(() => {
        if (showArticle && searchInput.current) {
            searchInput.current.focus()
        }
    }, [showArticle])

    const deleteArticle = async (articleId) => {
        props.setArticleListInfo(prev => {
            return {
                ...prev,
                list_detail: prev.list_detail.filter(value => value.article.id != articleId)
            };
        });
    }

    const handleFocus = (inputRef) => {
        if(inputRef.current){
            inputRef.current.select()
        }
    };

    const handleChangeQte = (e,idLineArticle) => {
        props.setArticleListInfo(prev => {
            return {...prev,list_detail: prev.list_detail.map(value => {
                if(value.article.id == idLineArticle){
                    return {...value,quantity: e.target.value}
                }
                else{
                    return value
                }
            })}
        });
    };

    const handleSubmitArticleListe = async (obj,setValidButton,resetFiltreItemsToPromo,setShowModalAdd) =>{
        setValidButton(true)

        if (!props.articleListInfo.list_detail.find(value => obj.some(val => val.article.id == value.article.id))) {
            props.setArticleListInfo(prev => {
                return {
                    ...prev,
                    list_detail: [...prev.list_detail, ...obj]
                };
            });
        }
        else {
            props.setArticleListInfo(prev => {
                return {
                    ...prev,
                    list_detail: prev.list_detail.map(value => {
                        let matching = obj.find(val => val.article.id == value.article.id)
                        return matching ? {...value, quantity: parseInt(value.quantity)+1} : value
                    })
                };
            });
        }

        props.setReload(Date.now())
        if(resetFiltreItemsToPromo) resetFiltreItemsToPromo()
        setValidButton(false)
        if(setShowModalAdd) setShowModalAdd(false)
        searchInput.current.focus()
    }

    const addNewItem = async (e,articleid,inputname,articleBar) =>{//selection l'article dans l'input data
        let article = (e) ? e.target.value : articleid
        let urlArticle = (e) ? "api/erp/article/reference/" : "api/erp/article/one/"
        
        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+urlArticle+article+'/'+zoneArticleListe
        ).then((response) => {
            if(response.data.hasOwnProperty('valid') && !response.data.valid){
                swal.fire(t('articleNoReferenceFind'), "", "error");
            }else{
                let articleFind = (e) ? response.data.data.article : response.data.data
                // Un article non lié au stock (havestock false) ne doit pas pouvoir être ajouté à l'ajustement de masse
                if(!articleFind.havestock){
                    setLoadingSearchItem(false)
                    swal.fire(t('itemNoHavestock'), "", "error");
                    return
                }
                let obj =[
                    {article: articleFind, quantity: 1}
                ]

                handleSubmitArticleListe(obj,setLoadingSearchItem,false,false)
                setInputScan('')
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }

    let datasList = new Array
    Object.keys(props.articleListInfo).length!=0 && props.articleListInfo.list_detail.map((value,ind)=>{
        let obj = {
            masque:'',
            internalid: value.article.internalid,
            pr : value.article.pr,
            id: value.article.id,
            devise:(value.article.devise_achat!=null) ? value.article.devise_achat : '',//digit={(value.article.devise_achat!='XPF') ? 2 : 0}
            quantity: <input ref={inputQteRef.current[value.article.id]} onFocus={()=>handleFocus(inputQteRef.current[value.article.id])} disabled={validButton} type="number" value={value.quantity} className="form-control form-control-sm" onChange={(e)=>handleChangeQte(e,value.article.id)}/> ,
            stock: value.article.stock,
            action:
                <span className="d-flex justify-content-between align-items-center">
                    <DeleteActionButton deleteFunctionArgument={value.article.id} actionType={'typeRemoveX'} nameType={'remove'} toDelete={value.article.name} customClickEvent={deleteArticle}/>
                    <input
                        type="checkbox"
                        style={{cursor:'pointer'}}
                        checked={selectedRows.includes(value.article.id)}
                        onChange={() => toggleSelectRow('one',value.article.id)}
                    />
                </span>,
            index: ind + 1,
        }
        articleDataGenerator(obj,value.article,t)
        articlePriceUnitSuppDataGenerator(obj,value,suppPrice)
        props.customFields.forEach((item,index)=>{
            if(value.article.custom_fields){
                obj[item.name]=value.article.custom_fields[item.name]
            }
        })

        for (let i=0; i<maxConditionnement; i++){
            let numeroEnumere = i+1
            obj['name_'+numeroEnumere]= (value.article.hasOwnProperty('name_'+numeroEnumere) && value.article['name_'+numeroEnumere]!=null) ? value.article['name_'+numeroEnumere] : ''
            obj['reference_'+numeroEnumere]= (value.article.hasOwnProperty('reference_'+numeroEnumere) && value.article['reference_'+numeroEnumere]!=null) ? value.article['reference_'+numeroEnumere] : ''
            obj['quantity_'+numeroEnumere]= (value.article.hasOwnProperty('quantity_'+numeroEnumere) && value.article['quantity_'+numeroEnumere]!=null) ? value.article['quantity_'+numeroEnumere] : ''
        }

        suppPrice.map((item,index)=>{
            let numero = index+1
            let margePrixSupp = (value.article.hasOwnProperty('margeN_'+item['designation_'+numero]) && value.article['margeN_'+item['designation_'+numero]]!=null && value.article['margeN_'+item['designation_'+numero]]!=0) ? value.article['margeN_'+item['designation_'+numero]] : 0

            let margePercentPrixSupp = (value.article.hasOwnProperty('margeP_'+item['designation_'+numero]) && value.article['margeP_'+item['designation_'+numero]]!=null && value.article['margeP_'+item['designation_'+numero]]!=0) ? value.article['margeP_'+item['designation_'+numero]] : 0


            obj['price_'+item['designation_'+numero]]= (value.article.hasOwnProperty('price_'+item['designation_'+numero]) && value.article['price_'+item['designation_'+numero]]!==null && value.article['price_'+item['designation_'+numero]]!=='') ? value.article['price_'+item['designation_'+numero]] : ''

            obj['price_'+item['designation_'+numero]+'_ttc']= (value.article.hasOwnProperty('price_'+item['designation_'+numero]+'_ttc') && value.article['price_'+item['designation_'+numero]+'_ttc']!==null && value.article['price_'+item['designation_'+numero]+'_ttc']!=='') ? value.article['price_'+item['designation_'+numero]+'_ttc'] : ''

            obj['margeN_'+item['designation_'+numero]]= margePrixSupp

            obj['margeP_'+item['designation_'+numero]]= margePercentPrixSupp
        })

        categorieTva.map((categorie)=>{
            obj['taux_'+categorie.name]= (value.article.hasOwnProperty('taux_'+categorie.name) && value.article['taux_'+categorie.name]!=null) ? value.article['taux_'+categorie.name] : ''
        })

        datasList.push(obj)
    })

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
                setPerPage(page)
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: datasList.length
    };

    let columnsInit = [
        {
            dataField: "action",
            text: "Actions",
            editable: false,
            headerClasses: 'head-action-row',
            classes: 'body-action-row',
            headerFormatter: (column) => (
                <span className="d-flex justify-content-between align-items-center">
                    {datasList.length!=0 &&
                        <input
                            type="checkbox"
                            style={{cursor:'pointer'}}
                            checked={allRowsSelected}
                            onChange={() => toggleSelectRow('all')}
                        />
                    }
                    <span>{column.text}</span>
                </span>
            ),
        },
        {
            dataField: "internalid",
            text: t('internalId'),
            editable: false,
            hidden: (columnShow.includes("internalid")) ? false : true,
            sort: false,
        },
        {
            dataField: "stock",
            text: 'Stock',
            hidden: (columnShow.includes("stock")) ? false : true,
            sort: false,
        },
        {
            dataField: "quantity",
            text: t('addOrRemoveStock'),
            hidden: (columnShow.includes("quantity")) ? false : true,
            sort: false,
        },
        {
            dataField: "pr",
            text: t('pr'),
            hidden: (columnShow.includes("pr")) ? false : true,
            formatter: (rowData) => (<FormatedPrice langRegion={'fr-FR'} devise={authParam.company.devise} digit={2} priceToFormat={rowData} />),
        },
    ];

    const headerSortingStyle = { backgroundColor: '#c8e6c9' };

    let columns=[
        ...columnsInit,
        ...articleColumnGenerate(articleListErp,columnShow,headerSortingStyle,articleEditionDatatable,props.optionsDataTable,props.ourOptionsDataTable,t,authParam),
        ...enumereColumnGenerate(maxConditionnement,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
        ...priceSuppColumnGenerate(suppPrice,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
        ...tauxTvaColumnGenerate(categorieTva,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
        ...customFieldsColumnGenerate(props.customFields,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam)
    ]

    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.article_fields_stock_adjustment_reorganize){
            let cookieLecture = localStorage.article_fields_stock_adjustment_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{//on boucle sur toutes les colonnes existante sur le cookie de réorganisation 
                columns.map(item=>{//on vérifie dans l'array columns si les colonnes qu'il contient sont présent dans le cookie 
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle colonne à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    arrCol.push(item);
                }
            })
            columnCookie = arrCol

            if(arrCol.length !== cookieLecture.length){ 
                //Si des données articles ont été ajoutées ou si une configuration d'access à été faite pour rajouter ou retirer des colonnes, le cookie de réorganisation sera mis à jour 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage("article_fields_stock_adjustment_reorganize",arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        }
        setColumnOrganize(columnCookie)
    }, [props.customFields,props.articleListInfo])

    // columnOrganize est figé après le montage : on rafraîchit explicitement le headerFormatter
    // de la colonne action (case "tout sélectionner") à chaque changement de sélection
    useEffect(function () {
        setColumnOrganize(prev => prev.map(col =>
            col.dataField=='action'
                ? { ...col, headerFormatter: (c) => (
                    <span className="d-flex justify-content-between align-items-center">
                        {datasList.length!=0 &&
                            <input
                                type="checkbox"
                                style={{cursor:'pointer'}}
                                checked={allRowsSelected}
                                onChange={() => toggleSelectRow('all')}
                            />
                        }
                        <span>{c.text}</span>
                    </span>
                )}
                : col
        ))
    }, [allRowsSelected, props.articleListInfo])

    useEffect(function () {
        if(localStorage.article_fields_Stock_Adjustment){
            let cookieColumnShow = localStorage.article_fields_Stock_Adjustment.split(',')
            let columnsDatas = [] //contient toutes les dataFields de columns
            let arrColumnShow = [] //contient toutes les données sans doublons
            let arrColumnShowDoublon = [] //contient les doublons
            let arrColumnShowIntrus = [] // continent les fausse données

            columns.map(item=>{
                columnsDatas.push(item.dataField)
            })

            cookieColumnShow.map(value=>{
                //on vérifie si le cookie contien des doublons
                if(!arrColumnShow.includes(value)){
                    arrColumnShow.push(value)
                }else{
                    //Si value existe dejà c'est qu'il y a un doublon 
                    arrColumnShowDoublon.push(value)
                }
                //on vérifie si les données du cookies sont des données qui exisent dans le tableau columns
                if(!columnsDatas.includes(value)) arrColumnShowIntrus.push(value)
                
            })

            if(arrColumnShowDoublon.length!=0 || arrColumnShowIntrus.length!=0){ 
                //Si le cookie contient des doublons et des données qui n'existe pas en meme temps
                let uniformData = arrColumnShow.filter(value=> !arrColumnShowIntrus.includes(value))

                setLocalStorage("article_fields_Stock_Adjustment",uniformData.join(),{ path: "/", expires: expire_date })
            }
        }
    }, [])

    const handleToggleColumns = (column,indexToEdit) => {
        if(column.toggle){
            var newColumnShow = columnShow.filter(value=>value!=column.dataField)

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = true

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
            
        }
        else{
            var newColumnShow = [...columnShow,column.dataField]

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = false

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
        }
        setLocalStorage("article_fields_Stock_Adjustment",newColumnShow.join(),{ path: "/", expires: expire_date }) 
    }

    const handleSubmit = async () =>{
        setValidButton(true)

        let articles=[]
        let quantity=[]

        props.articleListInfo.list_detail.forEach(value=>{
            articles.push(value.article.id)
            quantity.push(value.quantity)
        })

        let obj = {
            section: sectionArticleListe,
            zone: zoneArticleListe,
            memo: memo,
            articles: articles,
            quantity: quantity
        }
        if (haveBins && binsArticleListe) obj.bins = binsArticleListe

        const response  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/article/mass_stock_ajust",obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
                setValidButton(false)
            }
            else{
                if (props.setReload) props.setReload(Date.now())
                props.setArticleListInfo(prev => {
                    return {...prev,list_detail:[]}
                })
                handleResetForm()
                setValidButton(false)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
            setValidButton(false)
        })
    }

    /**
     * Ouvre la modal d'impression d'étiquettes pour toute la liste d'ajustement en cours.
     * La quantité imprimée par article correspond à la quantité saisie dans "Ajouter/retirer du stock" (value.quantity).
     */
    const beforePrintTag = () => {
        //La quantité peut être négative (retrait de stock) : on imprime toujours au moins 1 étiquette par article, en valeur absolue
        let arr = props.articleListInfo.list_detail.map(value => ({article:value.article, qte:Math.abs(+value.quantity) || 1}))
        setArticleListPrint(arr)
        setShowPrintTagModal(true)
    }

    const handleConfirmation = () => {
        swal.fire({
            title: t('stockAdjustmentConfirmation'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('btnYes'),
            cancelButtonText: t('btnNo'),
        })
        .then((result) => {
            if (result.value) {
                handleSubmit()
            }
        });
    }

    // Reset des sélections
    const handleResetForm = () => {
        setZoneArticleListe('')
        setBinsArticleListe('')
        setMemo('')
        if (props.module!='erp') {
            setSectionArticleListe(props.section.id)
        }
        else {
            setSectionArticleListe('')
        }
        props.setArticleListInfo(prev => {
            return {...prev,list_detail:[]}
        })
        setShowArticle(false)
    }

    // Contrôle validité des données
    useEffect(function () {
        if (zoneArticleListe!='' && sectionArticleListe!='' && memo!='' && props.articleListInfo.list_detail.length>0) {
            if (haveBins) {
                if (binsArticleListe!='') {
                    setValidData(true)
                }
            } else {
                setValidData(true)
            }
        } else {
            setValidData(false)
        }
    }, [zoneArticleListe,binsArticleListe,memo,props.articleListInfo])

    return (
        <>
            {loadPrintList &&
                <div className={props.module=='wms' ? 'superpositionLoaderPrintTagWms loadingMessageTags' : 'superpositionLoaderPrintTag loadingMessageTags'}>
                    {t('loadingTagsMsg')}
                    <Loading></Loading>
                </div>
            }
            <Modal size="lg" show={showPrintTagModal} onHide={() => setShowPrintTagModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('tagPrint')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalTagPrintForm
                        articleListPrint={articleListPrint}
                        listPrint={true}
                        from={props.module}
                        setLoadPrintList={setLoadPrintList}
                        paramPrinter={false}
                        imprimanteType="image_file"
                    />
                </Modal.Body>
            </Modal>
            <FormulaireAjoutArticleStockAdjustment
                liaisons={props.liaisons}
                customFields={props.customFields} 
                setToast={setToast}
                customInterface={props.customInterface}
                setCustomInterface={props.setCustomInterface}
                setReload={props.setReload}
                articleListInfo={props.articleListInfo}//Info sur la liste d'article
                setArticleListInfo={props.setArticleListInfo}
                module={props.module}
                allSections={props.allSections}
                section={props.section}
                showArticle={showArticle}
                setShowArticle={setShowArticle}

                zoneArticleListe={zoneArticleListe}
                setZoneArticleListe={setZoneArticleListe}
                binsArticleListe={binsArticleListe}
                setBinsArticleListe={setBinsArticleListe}
                haveBins={haveBins}
                setHaveBins={setHaveBins}
                memo={memo}
                setMemo={setMemo}
                sectionArticleListe={sectionArticleListe}
                setSectionArticleListe={setSectionArticleListe}

                handleResetForm={handleResetForm}
            />
            {showArticle &&
                <CardPerso header={t('listOfItems')+' :'}>
                    <small>
                        <ToolkitProvider
                            keyField="index"
                            data={datasList}
                            columnToggle
                            columns={columnOrganize}
                        >
                        {(propst) => (
                            <>
                                <div className="row w-100 mb-3 d-flex align-items-baseline">
                                    <div className="col-auto">
                                        <ColumDataTableReorganize 
                                            columnOrganize={columnOrganize}
                                            setColumnOrganize={setColumnOrganize}
                                            setCookie={setLocalStorage}
                                            cookieName='article_fields_stock_adjustment_reorganize'
                                            { ...propst.columnToggleProps } 
                                            executWhenToggle={handleToggleColumns}
                                            showColumnOrganize={showColumnOrganize}
                                            setShowColumnOrganize={setShowColumnOrganize}
                                            btnSwitch={true}//pour affiche ou non le btn swith
                                            initSwith={false}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                        />&nbsp;&nbsp;&nbsp;
                                    </div>
                                    <div className="col-auto d-flex align-items-baseline">
                                        <label style={{minWidth: 'max-content'}}>{t('addItem')}:</label>&nbsp;&nbsp;&nbsp;
                                        <div>
                                            <ArticleBarSearch 
                                                loadingSearchItem={loadingSearchItem}
                                                loadItems={loadItems}
                                                listSearchItem={listSearchItem}
                                                datas={datas}
                                                setDatas={setDatas}
                                                valueInput={inputScan}
                                                setValueInput={setInputScan}
                                                handleSubmit={addNewItem}
                                                searchInput={searchInput}
                                                noBlur={true}
                                                icon='true'
                                                autoFocus={showArticle}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">

                                    </div>
                                    <div className="col-auto d-flex align-items-baseline">
                                        {selectedRows.length!=0 &&
                                            <>
                                                <button
                                                    className="btn btn-sm btn-danger"
                                                    onClick={()=>bulkDeleteArticles()}
                                                    disabled={validButton}
                                                >
                                                    {t('deleteSelection')} ({selectedRows.length})
                                                </button>&nbsp;&nbsp;&nbsp;
                                            </>
                                        }
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={()=>beforePrintTag()}
                                            disabled={(validButton || datasList.length==0)}
                                        >
                                            {t('printItemTags')}
                                        </button>&nbsp;&nbsp;&nbsp;
                                        <button
                                            className="btn btn-sm btn-primary"
                                            onClick={()=>handleConfirmation()}
                                            disabled={(validButton || !validData)}
                                        >
                                            {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidateStockAdjustment')}
                                        </button>
                                    </div>
                                </div>
                                {columnOrganize.length!=0 &&
                                    <div className="position-relative">
                                        <CustomDataTable 
                                            propst={propst}
                                            paginationOptions={paginationOptions}
                                            columnShow={columnShow}
                                            defaultSortDirection="asc"
                                        />
                                    </div>
                                }
                            </>
                        )}
                        </ToolkitProvider>
                    </small>
                </CardPerso>
            }
        </>
    );
}

export default StockAdjustmentDetailTable;


